<template>
    <div class="video-library-wrapper">
        <Tabs :tabsConfig="tabsConfig" @tabClick="tabClick">
            <component :is="currentComponentName" :refercence="refercence" @checkClick="checkHandler" />
        </Tabs>
    </div>
</template>

<script>
import Tabs from "@/views/zhiji/bComponents/switchs/Tabs";
import VLinkVideo from "./components/VLinkVideo";
import AddClassifyMaterial from "@/views/zhiji/components/materialLibrary/AddClassifyMaterial";
import ShowVideoViewModal from "@/views/zhiji/components/questionEdit/modals/VideoViewModal";

export default {
    name: "VideoLibraryPage",
    props: ["refercence"],
    components: {
        Tabs,
        VLinkVideo
    },
    data() {
        return {
            currentComponentName: "VLinkVideo"
        };
    },
    computed: {
        tabsConfig() {
            return [
                {
                    tabName: this.$t("zhiji.materialLibrary.vlinkVideo"),
                    contentName: "VLinkVideo"
                }
            ];
        }
    },
    methods: {
        tabClick(data) {
            this.currentComponentName = data.componentName;
            this.$emit("tabClick", data);
        },
        checkHandler(data) {
            this.$emit("checkClick", data);
        }
    }
};
</script>

<style scoped lang="less">
.video-library-wrapper {
    background: #f2f7fb;
    height: 100%;
    box-sizing: border-box;
}
</style>
